import React from "react";
import Education from "./Education";

function EducationList() {
  return (
    <div className="mt-[40px]">
      <Education
        title={"Btech, CSE"}
        subTitle={"Patiala - Thapar University"}
        date={"2018 - 2022"}
      />
      <Education
        title={"CBSE, 12th"}
        subTitle={"Rampur - Dayawati Modi Academy, 244901"}
        date={"2016"}
        reverse={"flex-row-reverse"}
      />
      <Education
        title={"CBSE, 10th"}
        subTitle={"Rampur - Dayawati Modi Academy, 244901"}
        date={"2014"}
        height={"h-0"}
      />
    </div>
  );
}

export default EducationList;
